import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=239240e1&"
import script from "./transform.vue?vue&type=script&lang=js&"
export * from "./transform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports